import { ResumePraticaDto } from "@api/client";
import { createReducer } from "@reduxjs/toolkit";
import AuthService from "core/auth/auth.service";
import { praticaAvviaPratica, praticaRiprendi, praticaSetId } from "./actions";

export interface PraticaReducerType {
	idPratica: string | undefined;
	reopenPratica: ResumePraticaDto | undefined;
}

const initialState: PraticaReducerType = {
	idPratica: sessionStorage.getItem("idPratica") || undefined,
	reopenPratica: JSON.parse(sessionStorage.getItem("reopenPratica") || "null"),
};

export const praticaReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(praticaSetId, (state, action) => {
			state.idPratica = action.payload;
		})
		.addCase(praticaAvviaPratica.fulfilled, (state, action) => {
			state.idPratica = action.payload?.idPratica;

			if (action?.payload?.idPratica) sessionStorage.setItem("idPratica", action.payload.idPratica);
		})
		.addCase(praticaRiprendi.fulfilled, (state, action) => {
			console.log("Action payload:", action.payload); // Log the payload to check its structure

			sessionStorage.setItem("reopenPratica", JSON.stringify(action.payload));

			state.idPratica = action.payload?.idPratica;
			state.reopenPratica = action.payload;

			if (action?.payload?.idToken) AuthService.setAuthentication(action?.payload?.idToken);

			if (action?.payload?.idPratica) sessionStorage.setItem("idPratica", action.payload.idPratica);

			if (action?.payload?.idSoggetto) {
				sessionStorage.setItem("idCompany", action.payload.idSoggetto);
			} else {
				sessionStorage.setItem("idCompany", "0");
			}

			if (action?.payload?.idCliente) sessionStorage.setItem("idCliente", action.payload.idCliente);
		});
});
